<template>
  <div class="multiselect__main">

    <Multiselect
      v-model="selectedOption"
      :options="normalizedOptionsWithAbsolute"
      :multiple="false"
      :close-on-select="true"
      :placeholder="placeholder? placeholder : 'Введите список пунктов по одному'"
      :preselect-first="false"
      :allow-empty="true"
      label="label"
      track-by="value"
      tag-placeholder="Добавить"
      select-label=""
      deselect-label=""
      selected-label=""
      deselect-group-label=""
    >
      <template #noResult>
        Ничего не найдено
      </template>
    </Multiselect>
  </div>
</template>

<script>
import Multiselect from 'vue-multiselect'

export default {
  name: "CustomMultiselect",
  components: { Multiselect },
  props: {
    options: { type: Array, required: true },
    placeholder: { type: String, default: '' },
    modelValue: { required: false, default: null }
  },
  computed: {
    normalizedOptions() {
      return this.options.map(opt => {
        if (typeof opt === 'object' && opt !== null && 'value' in opt && 'label' in opt) {
          return opt
        } else {
          return { label: String(opt), value: opt }
        }
      })
    },
    normalizedOptionsWithAbsolute() {
      return [
        ...this.normalizedOptions
      ]
    },
    selectedOption: {
      get() {
        return this.normalizedOptionsWithAbsolute.find(opt => opt.value === this.modelValue) || null
      },
      set(val) {
        this.$emit('update:modelValue', val?.value ?? null)
      }
    }
  }
}
</script>


<style scoped>
.me {
  width: 100%;
}

:deep(.multiselect-light .multiselect) {
  background: #ffffff !important;
  border: 1px solid #e6e9ee !important;
  color: #0f1724 !important;
  border-radius: 8px !important;
}

:deep(.multiselect-light .multiselect__input) {
  color: #0f1724 !important;
}

::v-deep(.multiselect-light .multiselect__placeholder) {
  color: #6b7280 !important;
}

:deep(.multiselect__tags) {
  border: 0.1rem solid var(--color-1) !important;
}
:deep(.multiselect__select) {
  margin: 0.7rem !important;
  padding: 0 !important;
  width: 1rem !important;
  height: 1rem !important;
  display: flex !important;
  align-items: center !important;
}
:deep(.multiselect__select::before) {
  margin-top: 0 !important;
  top: 0 !important;
}

:deep(.multiselect-light .multiselect__tag) {
  background: rgba(37,99,235,0.12) !important;
  border: 1px solid rgba(37,99,235,0.25) !important;
  color: #2563eb !important;
  border-radius: 6px;
  padding: 2px 6px;
	display: flex;
	font-size: 1rem;
  flex-direction: row;
  flex-wrap: nowrap;
  align-items: center;
	width: fit-content;
}
:deep(.multiselect-light .multiselect__tag span) {
	padding-right: 1rem;
}
:deep(.multiselect-light .multiselect__tag-icon) {
  color: #2563eb !important;
	line-height: 1.1;
}

:deep(.multiselect-light .multiselect__option) {
  background: #ffffff !important;
  color: #0f1724 !important;
  padding: 8px 12px;
}

:deep(.multiselect-light .multiselect__option--highlight) {
  background: #eef2ff !important;
}

:deep(.multiselect-light .multiselect__option--selected) {
  background: rgba(37,99,235,0.1) !important;
  color: #2563eb !important;
}

:deep(.multiselect-light .multiselect__noResult),
:deep(.multiselect-light .multiselect__noOptions) {
  color: #6b7280 !important;
  padding: 8px 12px;
}

:deep(.multiselect__main input) {
  background: red !important;
}
@media (max-width: 350px) {
  .me { width: 100%; }
}
:deep(.multiselect__element span) {
	background: transparent !important;
	color: black !important;
  
}



:deep(.multiselect-light .multiselect__input) {
	background: transparent !important;
	color: black !important;
}

::v-deep(.modal__middle .nested-body__multiselect .multiselect .multiselect__content-wrapper) {
  border: 0.1rem solid var(--color-1) !important;
  overflow: hidden !important;
  border-radius: 0rem 0rem 0.5rem 0.5rem !important;
  border-top: 0 !important;
  width: 100%;
}

:deep(.multiselect__element) {
  border-bottom: 0.1rem solid var(--color-1) !important;
  transition: 0.3s ease all;
}
:deep(.multiselect__element:hover) {
  opacity: 0.5
}

</style>
